import React from "react";
import { TwitterTweetEmbedInArticle } from "../components/twitter-tweet-embed";
import { createRoot } from "react-dom/client";

export const hookArticleComponents = (el: ParentNode) => {
  const elements = el.querySelectorAll(".twitter-tweet-embed");
  Array.from(elements).forEach((item) => {
    const element = item as HTMLElement;

    const root = createRoot(element);
    root.render(
      <TwitterTweetEmbedInArticle tweetId={element.dataset.tweetId!} />
    );
  });
};
